module.exports = __webpack_public_path__ + "static/media/aa18.4a289144.jpg";